/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BrandLearningSummaryDto } from '../models/BrandLearningSummaryDto';
import type { ClearBrandLearningOverrideDto } from '../models/ClearBrandLearningOverrideDto';
import type { PreviewBrandLearningDto } from '../models/PreviewBrandLearningDto';
import type { SeedBrandLearningDto } from '../models/SeedBrandLearningDto';
import type { SetBrandLearningOverrideDto } from '../models/SetBrandLearningOverrideDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class BrandLearningService {
    /**
     * Get per-source brand-learning summary (aggregates + overrides + exemplar URLs + history) for the BrandCard / BrandKit UI.
     * @param businessId Business ID
     * @returns BrandLearningSummaryDto
     * @throws ApiError
     */
    public static brandLearningControllerGetSummaryV1(
        businessId: string,
    ): CancelablePromise<BrandLearningSummaryDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/businesses/{businessId}/brand-learning',
            path: {
                'businessId': businessId,
            },
        });
    }
    /**
     * Set a user override on a single field path.
     * @param businessId Business ID
     * @param source BrandLearning source
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public static brandLearningControllerSetOverrideV1(
        businessId: string,
        source: 'instagram' | 'tiktok' | 'linkedin' | 'facebook' | 'website' | 'manual',
        requestBody: SetBrandLearningOverrideDto,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/v1/businesses/{businessId}/brand-learning/{source}/overrides',
            path: {
                'businessId': businessId,
                'source': source,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Clear a user override, reverting to the mined value.
     * @param businessId Business ID
     * @param source BrandLearning source
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public static brandLearningControllerClearOverrideV1(
        businessId: string,
        source: 'instagram' | 'tiktok' | 'linkedin' | 'facebook' | 'website' | 'manual',
        requestBody: ClearBrandLearningOverrideDto,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/v1/businesses/{businessId}/brand-learning/{source}/overrides',
            path: {
                'businessId': businessId,
                'source': source,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Kick off a refresh for this source (fire-and-forget). Client receives PusherEvent.BrandLearningCompleted when mining finishes.
     * @param businessId Business ID
     * @param source BrandLearning source
     * @returns any
     * @throws ApiError
     */
    public static brandLearningControllerRefreshV1(
        businessId: string,
        source: 'instagram' | 'tiktok' | 'linkedin' | 'facebook' | 'website' | 'manual',
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/businesses/{businessId}/brand-learning/{source}/refresh',
            path: {
                'businessId': businessId,
                'source': source,
            },
        });
    }
    /**
     * Drop the persisted brand-learning row for this source (privacy controls + IG disconnect path).
     * @param businessId Business ID
     * @param source BrandLearning source
     * @returns void
     * @throws ApiError
     */
    public static brandLearningControllerResetV1(
        businessId: string,
        source: 'instagram' | 'tiktok' | 'linkedin' | 'facebook' | 'website' | 'manual',
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/businesses/{businessId}/brand-learning/{source}/reset',
            path: {
                'businessId': businessId,
                'source': source,
            },
        });
    }
    /**
     * Persist a cached preview blob (from POST /v1/brand-learning/preview) as the first BrandLearning row for this business. Idempotent — no-op if a row already exists with non-null lastRefreshedAt. Verifies the previewed handle/URL matches the current brand kit.
     * @param businessId Business ID
     * @param source BrandLearning source
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public static brandLearningControllerSeedFromPreviewV1(
        businessId: string,
        source: 'instagram' | 'tiktok' | 'linkedin' | 'facebook' | 'website' | 'manual',
        requestBody: SeedBrandLearningDto,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/businesses/{businessId}/brand-learning/{source}/seed',
            path: {
                'businessId': businessId,
                'source': source,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Onboarding preview: mine the supplied Instagram handle / website URL and return a transient brand-learning summary (no DB write).
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    public static brandLearningPreviewControllerPreviewV1(
        requestBody: PreviewBrandLearningDto,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/brand-learning/preview',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
